import React, { Component } from 'react';
import MegaNavMobileAccordion from './MegaNavMobileAccordion';

class MegaNavMobile extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.children.map((item, index) => {
                    return (
                        <MegaNavMobileAccordion
                            title={item.title}
                            key={index}
                            children={item.children}
                            link={item.link}
                        />
                    );
                })}
            </div>
        );
    }
}

export default MegaNavMobile;